// 国家列表
import { NativeModules, Platform } from 'react-native';

interface Cookie {
    [name: string]: string;
}

const cookie = Platform.OS === 'web' ? document.cookie : NativeModules?.CookieManager?.getCookie('');

export const getCookie = (name: string): string => {
    const cookie2 = Platform.OS === 'web' ? document.cookie : NativeModules?.CookieManager?.getCookie('');

    const cookieObj: Cookie = {};

    cookie2?.split(';')?.map((item: string) => {
        const arr = item.split('=');

        if (arr.length > 1) {
            const key = arr[0].trim();
            const value = arr[1];
            cookieObj[key] = value;
        }
    });
    // 离谱，ios在用户没登录时，拿到的userId是字符串的'(null)'
    if (cookieObj[name] === '(null)' && (name === 'userId' || name === 'ud')) return '';

    return cookieObj[name] || '';
};
